<div class="file-upload-wrapper">
  <!-- Área de upload -->
  <div
    class="file-upload-area"
    *ngIf="!uploadedFile && !isUploading"
    (click)="!readonly && fileInput.click()"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    [class.readonly]="readonly"
  >
    <input
      #fileInput
      type="file"
      class="file-input"
      accept=".pdf,.png,.jpg,.jpeg"
      (change)="onFileSelected($event)"
      [disabled]="readonly"
    />
    <div class="upload-content">
      <div class="upload-icon">
        <i class="fa fa-cloud-upload"></i>
      </div>
      <div class="upload-text">
        <p>Clique para fazer <span class="highlight">upload</span> ou</p>
        <p>arraste e solte</p>
        <p class="file-types">PDF, PNG, JPEG ou JPG</p>
      </div>
      <div class="document-icon">
        <i class="fa fa-file-text"></i>
      </div>
    </div>
  </div>

  <!-- Container de progresso (não usado por enquanto, mas mantido para consistência) -->
  <div class="upload-progress-container" *ngIf="isUploading">
    <div class="upload-progress-info">
      <i class="fa fa-spinner fa-spin"></i>
      <span>Fazendo upload...</span>
    </div>
    <div class="progress">
      <div
        class="progress-bar"
        role="progressbar"
        [style.width.%]="uploadProgress"
        [attr.aria-valuenow]="uploadProgress"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        {{ uploadProgress }}%
      </div>
    </div>
  </div>

  <!-- Container de arquivo enviado -->
  <div
    class="uploaded-file-container"
    *ngIf="uploadedFile && !isUploading && uploadProgress === 100 && uploadedFileKey"
  >
    <div class="uploaded-file-info">
      <i [class]="getFileIcon(uploadedFile)"></i>
      <div class="file-details">
        <span class="file-name">{{ uploadedFile.name }}</span>
        <span class="file-size">{{ (uploadedFile.size / 1024 / 1024).toFixed(2) }} MB</span>
      </div>
      <button
        *ngIf="!readonly"
        type="button"
        class="btn-remove-file"
        (click)="removeUploadedFile()"
        title="Remover arquivo"
      >
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="upload-success">
      <i class="fa fa-check-circle text-success"></i>
      <span>Upload concluído com sucesso!</span>
    </div>
  </div>

  <!-- Mensagem de erro -->
  <div class="alert alert-danger mt-2" *ngIf="uploadError">
    <i class="fa fa-exclamation-triangle"></i>
    {{ uploadError }}
  </div>
</div>
